import { call } from "redux-saga/effects";
import actions from "../constants/hubReconciliationActions";
import constants from "../constants/constants";
import { getDataFromAPI } from "../utils/sagas";
import { APIs } from "../utils/worker";

export function* getHubReconciliationList({ data }) {
  const reqParams = {
    url: `${APIs.baseURL}/hub-reconciliation-service/v1/hub-reconcile?pageNum=${data.page - 1}&pageSize=${data.pageSize}`,
    successAction: actions.GET_HUB_RECONCILIATION_LIST_SUCCESS,
    errorAction: actions.GET_HUB_RECONCILIATION_LIST_ERROR,
    params: {
      authToken: `Bearer ${data.token}`,
    },
  };
  const headers = {
    ...constants.HTTP_REQ_DEFAULT_HEADERS,
    "SMCS-PREMISE-ID": data.premiseId,
  };
  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET, headers);
}

export function* startHubReconciliation({ data }) {
  const reqParams = {
    url: `${APIs.baseURL}/hub-reconciliation-service/v1/hub-reconcile`,
    successAction: actions.START_HUB_RECONCILIATION_SUCCESS,
    errorAction: actions.START_HUB_RECONCILIATION_ERROR,
    params: {
      authToken: `Bearer ${data.token}`,
      premiseId: data.premiseId,
      premiseName: data.premiseName,
    },
  };
  const headers = {
    ...constants.HTTP_REQ_DEFAULT_HEADERS,
    "SMCS-PREMISE-ID": data.premiseId,
    "USER-ID": data.userId,
  };
  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.POST, headers);
}

export function* scanBarcode({ data }) {
  const reqParams = {
    url: `${APIs.baseURL}/hub-reconciliation-service/v1/hub-reconcile/scan`,
    successAction: actions.SCAN_BARCODE_SUCCESS,
    errorAction: actions.SCAN_BARCODE_ERROR,
    params: {
      authToken: `Bearer ${data.token}`,
      reconcileId: data.reconcileId,
      awbNumber: data.awbNumber,
    },
  };
  const headers = {
    ...constants.HTTP_REQ_DEFAULT_HEADERS,
    "SMCS-PREMISE-ID": data.premiseId,
    "USER-ID": data.userId,
  };
  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.POST, headers);
}

export function* closeHubReconciliation({ data }) {
  const reqParams = {
    url: `${APIs.baseURL}/hub-reconciliation-service/v1/hub-reconcile/close/${data.reconcileId}`,
    successAction: actions.CLOSE_HUB_RECONCILIATION_SUCCESS,
    errorAction: actions.CLOSE_HUB_RECONCILIATION_ERROR,
    params: {
      authToken: `Bearer ${data.token}`,
    },
  };
  const headers = {
    ...constants.HTTP_REQ_DEFAULT_HEADERS,
    "SMCS-PREMISE-ID": data.premiseId,
    "USER-ID": data.userId,
  };
  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.PUT, headers);
}

export function* getReportData({ data }) {
  const queryParams = new URLSearchParams({ type: "CLOSED" });
  if (data.status) {
    queryParams.set("status", Array.isArray(data.status) ? data.status.join(",") : data.status);
  }
  if (data.awbNumber) {
    queryParams.set("awbNumber", data.awbNumber);
  }

  const reqParams = {
    url: `${APIs.baseURL}/hub-reconciliation-service/v1/hub-reconcile/shipments/${data.reconcileId}?${queryParams.toString()}`,
    successAction: actions.GET_REPORT_DATA_SUCCESS,
    errorAction: actions.GET_REPORT_DATA_ERROR,
    params: {
      authToken: `Bearer ${data.token}`,
    },
  };
  const headers = {
    ...constants.HTTP_REQ_DEFAULT_HEADERS,
    "SMCS-PREMISE-ID": data.premiseId,
  };
  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET, headers);
}
